import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntil } from 'rxjs/operators';
import { Events } from 'src/app/utils/event-utils';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { ActivatedRoute } from '@angular/router';
import { DriversService } from '../../component/drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { animate, style, transition, trigger } from "@angular/animations";
import { getBrokersList, getTimeAndDistance } from 'src/app/utils/utils.common';
import { AgmMap } from '@agm/core';
import * as moment from 'moment-timezone';
import { CorporateService } from '../../component/corporate-user/corporate-service/corporate-service';
import { LevelOfServiceService } from '../../component/level-of-service/service/level-of-service.service';
import { ServiceAreasService } from '../../component/service-areas/service-areas-service/service-areas.service';
import { HolidayService } from 'src/app/component/extras/holidays/service/holiday.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
declare var $;
@Component({
  selector: 'app-trip-assign-modal',
  templateUrl: './trip-assign-modal.component.html',
  styleUrls: ['./trip-assign-modal.component.css'],
  animations: [
    trigger("openCloseAssignSlideOut", [
      transition(":enter", [
        style({ opacity: 0, transform: "translateX(100%)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 1, transform: "translateX(0)" })
        )
      ]),
      transition(":leave", [
        style({ opacity: 1, transform: "translateX(0)" }),
        animate(
          "750ms ease-in-out",
          style({ opacity: 0, transform: "translateX(-100%%)" })
        )
      ])
    ])
  ]
})
export class TripAssignModalComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;

  @Input('assignModalObj') trip: any;

  @Input() componentType: string;
  @Input() secondaryCompType: string;
  @Output() tripAssigned = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<any>();
   @Input() dateRange: any;
  agmMap;
  user;
  searchDriver;
  selectedDriver = null;
  googleSelectedDriver = null;
  nearbyDrivers = [];

  manifestList = [];
  isSubmitted = false;
  isAttendee = "";
  isLivePrediction = false;

  requestType = null;
  multiAssignTripNote = null;
  cancelTripModalObj;
  origin = { lat: 0.00000, lng: 0.00000 };
  driverLoc = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  preCorporate;
  preLevelOfServices = {};
  preSpaceTypes: any = {};
  preServiceAreas = {};
  isInfo = false;
  isAllowRoute = false;
  cooperateHolidays;
  assistList;
  selectedAssist = [];

  constructor(
    private assistService : AssistService,
    private holidayService: HolidayService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService,
    private corporateService: CorporateService,
    private driverService: DriversService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.getUser();

    if (this.trip && !Array.isArray(this.trip)) {
      this.origin = {
        lat: this.trip.jobOriginLatitude,
        lng: this.trip.jobOriginLongitude
      };
      this.destination = {
        lat: this.trip.jobDestinationLatitude,
        lng: this.trip.jobDestinationLongitude
      };

    }

    this.listenSocket();
    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypes(),
      this.getServiceAreas(),
    ];

    if (this.componentType !== 'Multiple Assign') {
      requests.push(this.getCorporateUserById());
    }

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      async ([res1, res2, res3, res4]) => {
        if (res1) {
          this.preLevelOfServices = await res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.preSpaceTypes = await res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res3) {
          this.preServiceAreas = await res3.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res4) {
          if (this.componentType !== 'Multiple Assign') {
            this.preCorporate = res4;
          }
        }
        this.getNearbyDriver();
      },
      error => {
        sweetAlert('Error', error, 'warning', 'OK');
      }
    );
    if (!Array.isArray(this.trip)) {
      this.getHolidaysByCooperate();
    }
  }

  getHolidaysByCooperate() {
    let param = {
      cooperate: this.trip.cooperate
    }
    this.holidayService.getHolidaysByCooperate(param).subscribe((data) => {
      if (data) {
        this.cooperateHolidays = data;
        //  if(this.cooperateHolidays && this.cooperateHolidays.length){
        //   this.checkHolidayForTrip(this.trip, this.cooperateHolidays);
        //  }
      }
    })
  }

  checkHolidayForTrip(trip, holidays) {
    const tripScheduleTime = moment(trip.scheduleTime).tz(this.user.timeZone);
    const holidayDays = [];

    for (let holiday of holidays) {
      const holidayStart = moment(holiday.startTime).tz(this.user.timeZone).startOf('day');
      const holidayEnd = moment(holiday.endTime).tz(this.user.timeZone).endOf('day');
      if (tripScheduleTime.isBetween(holidayStart, holidayEnd)) {
        holidayDays.push(holiday.name);
      }
    }

    return holidayDays;
  };

  ngOnChanges(changes): void {
    if (changes.trip && changes.trip.currentValue) {
      if (changes.trip.currentValue.attendees)
        this.isAttendee = changes.trip.currentValue.attendees;
      if (changes.trip.currentValue.driver)
        this.selectedDriver = changes.trip.currentValue.driver;
    }
  }

  ngAfterViewInit() {
    // this.agmElement.mapReady
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe((map) => {
    //     this.agmMap = map;
    //    let trafficLayer = new google.maps.TrafficLayer();
    //     trafficLayer.setMap(this.agmMap);
    //   });
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getAssisData();
        }
      });
  }

  getNearbyDriver() {
    let data: any = {}
    if (this.componentType !== 'Multiple Assign') {
      if (this.preSpaceTypes && this.trip.spaceType && this.preSpaceTypes[this.trip.spaceType] && this.preSpaceTypes[this.trip.spaceType].loadTime && this.preSpaceTypes[this.trip.spaceType].unloadTime) {
        data = {
          jobOriginLatitude: this.trip.jobOriginLatitude,
          jobOriginLongitude: this.trip.jobOriginLongitude,
          jobOriginAddress: this.trip.jobOriginAddress,

          fundingSource: this.trip.cooperate,
          spaceType: this.trip.spaceType,
          scheduleTime: this.trip.scheduleTime,
          isNearBy: true,
          loadTime: this.preSpaceTypes[this.trip.spaceType].loadTime,
          unloadTime: this.preSpaceTypes[this.trip.spaceType].unloadTime,
          milage: this.trip.milage,
          jobDestinationLatitude: this.trip.jobDestinationLatitude,
          jobDestinationLongitude: this.trip.jobDestinationLongitude,
          jobDestinationAddress: this.trip.jobDestinationAddress,

          appointmentTime: this.trip.appointmentTime,
        };

        if (this.trip.serviceArea) {
          data.serviceArea = this.trip.serviceArea
        }
      } else {
        sweetAlert('Error', "Space Type issue with trip/vehicle.", 'error', 'OK');
        return;
      }
    }


    this.driverService
      .getNearbyDrivers(data)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.drivers) {
          this.nearbyDrivers = data.drivers;
          // this.nearbyDrivers.sort( function( a, b ) { return a.priority - b.priority; } )

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  onSelectDriver(driver) {
    this.selectedDriver = driver;
    if (this.componentType !== 'Multiple Assign')
      this.driverLoc = {
        lat: driver.coords[1],
        lng: driver.coords[0]
      };

    this.manifestList = driver.assigns;
    // this.getManifestTrips();
  }

  validateHolidays() {
    if (this.cooperateHolidays && this.cooperateHolidays.length) {
      const resdays = this.checkHolidayForTrip(this.trip, this.cooperateHolidays);
      if (resdays && resdays.length) {
        sweetAlert('Alert', `Member may be unavailable due to ${resdays.toString()}. Please confirm before assigning the trip. `, 'warning', 'Yes, Assign', 'No')
          .then((result) => {
            if (result.value) {
              this.assignTrip();
            }
          });
      }else {
        this.assignTrip();
      }
    } else {
      this.assignTrip();
    }
  }

  assignAssistTrip() {
    // this.isSubmitted = true;
    this.requestType = 'Assign Attendee';
    const payload = {
      ...this.trip,
      attendees : this.selectedAssist && this.selectedAssist.length ?  this.selectedAssist :null
    };
    this.assignSingleTrip(payload);
  }


  assignTrip() {
    this.isSubmitted = true;
    if (this.selectedDriver) {
      if (this.componentType === 'Multiple Assign') {
        this.requestType = 'Multiple Assign';
        const data = {
          selectedTrips: this.trip,
          status: 'offered',
          driver: this.selectedDriver,
          note: this.multiAssignTripNote
        };
        this.assignMultipleTrips(data);
      } else {
        this.requestType = 'Assign';
        this.trip.driver = this.selectedDriver._id;
        this.trip.status = 'offered';
        this.trip.jobStatus = 'offered';
        this.assignSingleTrip(this.trip);

      }

    }
  }

  assignSingleTrip(payload) {

    this.assignTripService
      .assignTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          if (this.requestType === 'Un Assign') {
            this.tripAssigned.emit('Trip Un Assigned');
          } else if (this.requestType === 'Assign') {
            this.tripAssigned.emit('Trip Assigned');
          }else if (this.requestType === 'Assign Attendee') {
            this.tripAssigned.emit('Attendee Assigned');
          }
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  assignMultipleTrips(payload) {
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('All Trips Assigned');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      })
  }

  unAssignTrip() {
    // this.trip.status = 'unassigned';
    // this.trip.jobStatus = 'pending';
    // this.assignTripService
    //   .assignTrip(this.trip)
    //   .pipe(takeUntil(componentDestroyed(this)))
    //   .subscribe(data => {
    //     if (data) {
    //       this.tripAssigned.emit('Trip Un Assigned');

    //     }
    //   });
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'unassigned'
      }
      this.updateMultipleTrips(payload);
    } else {
      this.trip.jobStatus = 'pending';
      this.trip.status = 'unassigned';
      this.updateSingleTrip(this.trip);
    }
  }

  archiveTrip() {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'archived'
      }
      this.updateMultipleTrips(payload);
    } else {
      this.trip.status = 'archived';
      this.updateSingleTrip(this.trip);
    }
    // sweetAlert('Alert','Are you sure you want to archive the trip?','warning','Yes','No')
    // .then((result) => {
    //   if(result.value) {
    //     this.trip.status = "archived";
    //     this.assignTripService
    //       .assignTrip(this.trip)
    //       .subscribe(data => {
    //       if (data) {
    //       }
    //   });
    //   }
    //   else if(result.dismiss){
    //     // close();
    //   }
    // });
  }

  updateJob(assign, assignKey) {
    let params = {
      assignId: assign._id
    }
    params[assignKey] = !assign[assignKey];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
    this.tripAssigned.emit('Trip Assigned');
  }

  sendToMarketplace() {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      payload = {
        selectedTrips: this.trip,
        status: 'marketplaced'
      }
      this.updateMultipleTrips(payload);

    } else {
      this.trip.jobStatus = 'marketplaced';
      this.trip.status = 'unassigned'
      this.updateSingleTrip(this.trip);

    }
  }

  setRequestType(requestType) {
    this.requestType = requestType;
  }

  getETA() {
    this.assignTripService
      .getETA(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.trip.etaMessage = data.etaMessage;
        }
      });
  }

  getMiles(driverIndex, driver) {
    this.googleSelectedDriver = null;

    if (this.trip.jobOriginLatitude && this.trip.jobOriginLongitude && this.trip.jobDestinationLatitude && this.trip.jobDestinationLongitude) {
      const locationParams = {
        origin: this.trip.jobOriginLatitude + ' , ' + this.trip.jobOriginLongitude,
        destination: driver.coords[1] + ' , ' + driver.coords[0]
        // destination: vm.assign.jobDestinationLatitude + ' , ' + vm.assign.jobDestinationLongitude
      };
      locationParams['dbMiles'] = driver.miles || 0;
      locationParams['isLog'] = true;
      this.socketService.emit(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL, locationParams);
      // Socket.emit(‘assignTripManualFormETA’, locationParams);
      this.googleSelectedDriver = driver;
    } else {
      sweetAlert('Error', 'Please Select Pickup and DropOff Address', 'warning', 'OK');
    }
  }

  listenSocket() {
    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          if (data.assign) {
            this.trip.isReadyForPickup = data.assign.isReadyForPickup;
            this.trip.isVipTrip = data.assign.isVipTrip;
            this.trip.isConfirmedTrip = data.assign.isConfirmedTrip;
            this.trip.isVoiceMail = data.assign.isVoiceMail;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });

    this.socketService.addListener(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (!this.googleSelectedDriver) return;
        const driverIndex = this.nearbyDrivers.findIndex(driver => driver._id === this.googleSelectedDriver._id);
        if (data.success) {
          this.nearbyDrivers[driverIndex].googleETA = data.message;
        } else {
          this.nearbyDrivers[driverIndex].googleETA = null;
        }
      });
  }

  cancelTrip() {
    this.cancelTripModalObj = this.trip;
  }

  closeModal() {
    this.onCloseModal.emit('close');
  }

  closeConfirmation() {
    this.requestType = '';
  }

  modalClose() {
    $('#assignModal .close').click();
  }

  closeCancelModal() {
    this.cancelTripModalObj = null;
    this.tripAssigned.emit('Trip Updated');
    // this.onCloseModal.emit('close');
  }

  // <p class="text-sm text-main-light" *ngIf = "requestType === 'archive'" class="modal-title" id="myLargeModalLabel"> Are you sure you want to archive ?</p>
  //                 <p class="text-sm text-main-light" *ngIf = "requestType === 'market place'" class="modal-title" id="myLargeModalLabel">Are you sure you want to send this trip to marketplace?</p>
  //               <p class="text-sm text-main-light" *ngIf = "requestType === 'Un Assign'" class="modal-title" id="myLargeModalLabel">Are you sure you want to send this trip to unassigned?</p>
  _updateJob(trip) {
    let payload;
    if (this.componentType === 'Multiple Assign') {
      if (this.requestType === 'archive') {
        payload = {
          selectedTrips: trip,
          status: 'archived'
        }
      } else if (this.requestType === 'market place') {
        payload = {
          selectedTrips: trip,
          status: 'marketplaced'
        }
      } else if (this.requestType === 'Un Assign') {
        payload = {
          selectedTrips: trip,
          status: 'unassigned'
        }
      }
      this.updateMultipleTrips(payload);
    } else {
      if (this.requestType === 'archive') {
        this.trip.status = 'archived';
      } else if (this.requestType === 'market place') {
        this.trip.jobStatus = 'marketplaced';
      } else if (this.requestType === 'Un Assign') {
        this.trip.status = 'unassigned';
        this.trip.jobStatus = 'pending';
      }
      this.updateSingleTrip(trip);
    }
  }

  updateMultipleTrips(payload) {
    this.assignTripService
      .assignMultipleTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('Trip Assigned');
          // sweetAlert('Success', 'Trip Updated', 'success', 'OK');
        }
      });
  }

   updateSingleTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssigned.emit('Trip Assigned');
          // sweetAlert('Success', 'Trip Updated', 'success', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  returnTrip() {
    this.cancelTrip();
  }

  brokerList(key?) {
    if (key) {
      return getBrokersList[key];
    }
    return getBrokersList;
  }


  // getManifestTrips() {
  //   const payload = {
  //     scheduleTime: this.trip.scheduleTime,
  //     driverId: this.selectedDriver._id
  //   };
  //   this.manifestList = [];
  //   this.assignTripService
  //     .fetchManifestTrips(payload)
  //     .pipe(takeUntil(componentDestroyed(this)))
  //     .subscribe(async data => {
  //       if (data && data.assigns) {
  //         this.manifestList = data.assigns;
  //         const findTrip = this.manifestList.find(item => item._id === this.trip._id)
  //         if (!findTrip) {
  //           this.manifestList.push({ ...this.trip, isPurposeTrip: true });
  //         } else {
  //           findTrip.isPurposeTrip = true;
  //         }
  //        await this.manifestList.sort(
  //           (a, b) => <any>new Date(a.scheduleTime) - <any>new Date(b.scheduleTime)
  //         );

  //         await this.checkPossibility();
  //       }
  //     });
  // }


  async checkPossibility() {
    let lastTrip;
    if (this.selectedDriver && this.selectedDriver.coords && this.selectedDriver.coords.length) {
      lastTrip = this.selectedDriver;
    }

    for (let myTrip of this.manifestList) {
      if (!lastTrip) {
        lastTrip = myTrip;
        continue
      }
      await this.setNextTripPickupTime(lastTrip, myTrip);
      lastTrip = myTrip;
    }
  }
  async setNextTripPickupTime(lastTrip, currentTrip) {
    let puDistanceAndTime;
    if (lastTrip.coords && lastTrip.coords.length) {
      puDistanceAndTime = await getTimeAndDistance(
        lastTrip.coords[1], lastTrip.coords[0],
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude, 50
      );
    } else {
      puDistanceAndTime = await getTimeAndDistance(
        lastTrip.jobDestinationLatitude, lastTrip.jobDestinationLongitude,
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude, 50
      );
    }




    let minutesToAdd = 0;
    if (puDistanceAndTime) {
      if (currentTrip.tripRequirement === 'WAV') {
        minutesToAdd += 5;
      } else if (currentTrip.tripRequirement === 'Stretcher') {
        minutesToAdd += 15;
      } else {
        minutesToAdd += 2;
      }

      let approxPUCurrentTrip;
      if (lastTrip.coords && lastTrip.coords.length) {
        approxPUCurrentTrip = moment().tz(this.user.timeZone).add(puDistanceAndTime.timeInMinutes * minutesToAdd, 'minutes');

      } else {
        const lastAptTimePredic = lastTrip.approxDO ? lastTrip.approxDO.time : lastTrip.appointmentTime;
        approxPUCurrentTrip = moment(this.isLivePrediction ? lastAptTimePredic : lastTrip.appointmentTime).tz(this.user.timeZone).add(puDistanceAndTime.timeInMinutes * minutesToAdd, 'minutes');
      }
      // to check late or on time
      let approxPUCurrentTripDiff = moment(currentTrip.scheduleTime).tz(this.user.timeZone).diff(approxPUCurrentTrip, 'minutes', true);


      currentTrip.approxPU = {
        time: approxPUCurrentTrip.toISOString(),
        difference: approxPUCurrentTripDiff,
        pointsDistance: puDistanceAndTime
      };

      const doDistanceAndTime = await getTimeAndDistance(
        currentTrip.jobOriginLatitude, currentTrip.jobOriginLongitude,
        currentTrip.jobDestinationLatitude, currentTrip.jobDestinationLongitude, 50
      );

      if (doDistanceAndTime) {

        let approxDOCurrentTrip = moment(currentTrip.approxPU.time).tz(this.user.timeZone).add(doDistanceAndTime.timeInMinutes * minutesToAdd, 'minutes');
        // to check late or on time
        let approxDOCurrentTripDiff = moment(currentTrip.appointmentTime).tz(this.user.timeZone).diff(approxDOCurrentTrip, 'minutes', true);

        currentTrip.approxDO = {
          time: approxDOCurrentTrip.toISOString(),
          difference: approxDOCurrentTripDiff,
          pointsDistance: doDistanceAndTime
        };

      }
    }
  }


  onSelectedManifestTrip(item) {
    if (item.willProceed) return;
    item.isSelected = !item.isSelected;
  }

  async changePrediction() {
    this.isLivePrediction = !this.isLivePrediction;
    await this.checkPossibility();
  }

  getCorporateUserById() {
    return this.corporateService.getCorporateUserById(this.trip.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
  }

  getLevelOfService() {
    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypes() {
    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getServiceAreas() {
    return this.serviceArea.getServiceAreas({ status: 'active' });
  }

  openCloseInfo() {
    this.isInfo = !this.isInfo;
  }


  getAssisData(){
    let queryParams = {
      scheduleTime:  this.dateRange ?  this.dateRange[0]:this.trip.scheduleTime
    }
    this.assistService.getAssistList(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.assistList = data;

        if(this.trip.attendees){
          this.selectedAssist = this.trip.attendees;
        }
      }
    });
  }
  onChangeAssist(){
    console.log('selectedAssist', this.selectedAssist);
  }

  ngOnDestroy(): void {
  }
}
